import React from 'react';
import PropTypes from 'prop-types';
import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ModalFooter from '../common/modal/footer';

class OrderConfirmationFooter extends React.PureComponent {
    static propTypes = {
        progress_phase: PropTypes.string.isRequired,
        progress_status: PropTypes.string.isRequired,
        payment_method: PropTypes.string,
        forced_into_loading_state: PropTypes.bool.isRequired,
        onCancelClick: PropTypes.func,
        onConfirmClick: PropTypes.func,
        onDoneClick: PropTypes.func,
    };

    onCancelClick = () => {
        if (this.props.onCancelClick) {
            this.props.onCancelClick();
        }
    };

    onConfirmClick = () => {
        if (this.props.onConfirmClick) {
            this.props.onConfirmClick();
        }
    };

    onDoneClick = () => {
        if (this.props.onDoneClick) {
            this.props.onDoneClick();
        }
    };

    focusOnConfirmButton = () => {
        if (this.confirmButton) {
            this.confirmButton.focus();
        }
    };

    render() {
        const { t } = this.props;
        let confirm_button_text = t('confirm_order');
        if (
            this.props.payment_method === 'online' &&
            this.props.total.toFloat() > 0.0
        ) {
            confirm_button_text = t('pay_now');
        }

        const showDoorDashDriveMessage =
            this.props.location &&
            this.props.location.delivery.mode == 'door_dash_drive' &&
            this.props.method == 'delivery';

        const showCancelButton =
            this.props.progress_phase === 'unconfirmed' ||
            (this.props.progress_phase === 'confirming' &&
                this.props.payment_processor?.form_type !== 'direct' &&
                this.props.forced_into_loading_state === false);

        return (
            <ModalFooter>
                {showDoorDashDriveMessage && (
                    <div className="m2g-order-confirmation-footer-door-dash-drive-message">
                        {t('door_dash_drive_message')}
                    </div>
                )}
                <ModalFooter.Right>
                    {showCancelButton && (
                        <button
                            onClick={this.onCancelClick}
                            data-cancel
                            className="m2g-order-confirmation-cancel-button m2g-button m2g-button--fat m2g-button--cancel"
                        >
                            {t('cancel')}
                        </button>
                    )}

                    {this.props.progress_phase !== 'confirmed' && (
                        <button
                            ref={el => (this.confirmButton = el)}
                            onClick={this.onConfirmClick}
                            data-confirm
                            className={`m2g-order-confirmation-confirm-button m2g-button m2g-button--fat m2g-button--primary ${
                                this.props.progress_phase === 'confirming'
                                    ? 'm2g-button--disabled'
                                    : ''
                            }`}
                        >
                            <span
                                data-confirm-icon
                                className="m2g-order-confirmation-confirm-button-icon m2g-icon--tick m2g-icon m2g-icon--medium m2g-hidden"
                            />

                            {this.props.progress_phase === 'unconfirmed' &&
                                this.props.forced_into_loading_state ===
                                    false && (
                                    <span className="m2g-order-confirmation-confirm-button-text--unconfirmed">
                                        <span>{confirm_button_text}</span>
                                    </span>
                                )}

                            {(this.props.progress_phase === 'confirming' ||
                                this.props.forced_into_loading_state ===
                                    true) && (
                                <span className="m2g-order-confirmation-confirm-button-text--confirming">
                                    {(this.props.progress_status !==
                                        'pending payment' ||
                                        this.props.forced_into_loading_state ===
                                            true) && (
                                        <span>
                                            {t('confirming_order')}&nbsp;
                                            <span className="m2g-dot-loader">
                                                <span>.</span>
                                                <span>.</span>
                                                <span>.</span>
                                            </span>
                                        </span>
                                    )}
                                    {this.props.progress_status ===
                                        'pending payment' && (
                                        <span>
                                            {t('pending_payment')}&nbsp;
                                            <span className="m2g-dot-loader">
                                                <span>.</span>
                                                <span>.</span>
                                                <span>.</span>
                                            </span>
                                        </span>
                                    )}
                                </span>
                            )}
                        </button>
                    )}

                    {this.props.progress_phase === 'confirmed' &&
                        this.props.forced_into_loading_state === false && (
                            <button
                                onClick={this.onDoneClick}
                                data-done
                                className="m2g-order-confirmation-done-button m2g-button m2g-button--fat"
                            >
                                {t('done')}
                            </button>
                        )}
                </ModalFooter.Right>
            </ModalFooter>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(
    OrderConfirmationFooter
);
